import React, { useEffect, useState } from 'react'
import T from 'i18n-react'
import CSSModules from 'helpers/CSSModulesUtil'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose, nest } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import { Card } from 'react-toolbox/lib/card'

import Actions from './Actions'
import SelectProfileDialog from './SelectProfileDialog/index'
import Table from './Table'
import {
  default as Collapse
} from 'components/fulcrum/collapse/Collapse'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'

import sagas from './sagas'
import {
  MODULE_NAME,
} from './constants'

import {
  testConfigNamesSelector,
  flattenedTestListSelector,
  flattenedTestProfilesSelector
} from './selectors'

import {
  detailsSelector
} from '../View/selectors'

import {
  fetchTestConfig,
  fetchTestProfiles,
  postTestConfig,
} from './actions'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    details: detailsSelector(state),
    testConfigNames: testConfigNamesSelector(state),
    testList: flattenedTestListSelector(state),
    testProfiles: flattenedTestProfilesSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTestConfig: (sku) => dispatch(fetchTestConfig(sku)),
    fetchTestProfiles: (details) => dispatch(fetchTestProfiles(details)),
    postTestConfig: (details) => dispatch(postTestConfig(details)),
  }
}

const FulcrumTestSuiteConfiguration = ({ details, testConfigNames, testList, testProfiles, fetchTestConfig, fetchTestProfiles, postTestConfig }) => {
  const [dialogActive, setDialogActive] = useState(false)
  const [collapse, setCollapse] = useState(false)
  useEffect(() => {
    if (details.sku) fetchTestConfig(details.sku)
  }, [details.sku])

  const onSave = (modifiedConfig) => {
    postTestConfig({
      sku: details.sku,
      segment: details.segment,
      ...modifiedConfig,
    })
    toggleDialogActive()
  }

  const toggleDialogActive = () => setDialogActive(!dialogActive)

  const emptyTestListMessage = (
    <div styleName='emptyStateMessage'>
      {T.translate('containers.product.fulcrumTestSuiteConfiguration.index.emptyTestListMessage')}
    </div>
  )

  return (
    <Card theme={styles}>
      <SelectProfileDialog
        active={dialogActive}
        toggleActive={toggleDialogActive}
        onSave={(modifiedConfig) => onSave(modifiedConfig)}
        initConfig={testConfigNames}
        testProfiles={testProfiles}
        fetchTestProfiles={() => fetchTestProfiles(details)}
      />
      <CardHeader title={T.translate('containers.product.fulcrumTestSuiteConfiguration.index.title')}>
        <Actions
          collapse={collapse}
          setCollapse={() => setCollapse(!collapse)}
          onEdit={toggleDialogActive}
        />
      </CardHeader>
      <Collapse collapse={collapse}>
        {
          testList.length ? (
            <Table
              source={testList}
            />
          ) : emptyTestListMessage
        }
      </Collapse>
    </Card>
  )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })

const enhance = compose(
  withConnect,
  withRouter,
  withSagas,
  withStyle
)

const FulcrumTestSuiteSection = enhance(FulcrumTestSuiteConfiguration)

export default nest(Section, FulcrumTestSuiteSection)
